import axios from 'axios'
import localforage from 'localforage'
import router from '@/router'
import store from '@/store'
import $loading from 'vue-load-progress'
import VueToast from 'vue-toastr-2/src/toastr.min'
import site_style from './site_style.js'

// const verb = ''
// const message = ''
// const title = ''
// const options = null

const toast = VueToast

const http = axios.create({
  baseURL: process.env.API_URL
})

// const setSearching = (state) => {
//   store.dispatch('setSearching', { isSearching: state })
// }

const setToast = (verb, message, title, options) => {
  store.dispatch('toast', {verb, message, title, options, toast})
}

const intercepRequest = async (config) => {
  $loading.color = '#f6b428'
  $loading.height = 6
  $loading.trickle = true
  $loading.trickleSpeed = 250
  $loading.start()
  // if (window.location.pathname.indexOf('/transacoesCompraVenda') === -1) {
  // }
  const token = await localforage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}

const intercepRequestError = (error) => {
  let rejection = error.request
  if (error != null && error.status !== undefined && error.status === 500) {
    setToast('error', 'Houve um erro no servidor, por favor tente mas tarde.', '', null)
  }

  if (error.status === 401 && error.config.url.indexOf('login') < 0) {
    setToast('info', rejection.data.message, '', null)
    router.push({ name: 'index' })
  }

  if (error.status === 405 || error.status === 404 || error.status === 403) {
    $loading.done()
    // console.log('Error!', error.statusText)
  }

  if (error.status === 400) {
    if (error.data && error.data.message) {
      setToast('warning', rejection.data.message, '', null)
      // console.log('warning', 'Atenção!', error.data.message)
    } else {
      setToast('warning', 'Por favor verifique os valores digitados.', '', null)
      // console.log('warning', 'Atenção!', 'Por favor verifique os valores digitados.')
    }
  }
  // setSearching(false)
  $loading.done()
  return error.response
}

const intercepResponse = (response) => {
  response.config.method = response.config.method.toUpperCase()
  // console.log(response.config.url)

  if ((response.config.method === 'POST' || response.config.method === 'PUT' || response.config.method === 'DELETE') &&
    response.config.url.indexOf('rest') > 0 &&
    response.config.url.indexOf('login') === -1 &&
    response.config.url.indexOf('indicacoes') === -1 &&
    response.config.url.indexOf('registro') === -1 &&
    response.config.url.indexOf('interno') === -1 &&
    response.config.url.indexOf('checkCode') === -1 &&
    response.config.url.indexOf('checkSelfie') === -1 &&
    response.config.url.indexOf('acessodigital/message') === -1 &&
    response.config.url.indexOf('solicitarVerificacaoDados') === -1 &&
    response.config.url.indexOf('solicitarNovoEmailVerificacao') === -1 &&
    response.config.url.indexOf('solicitarNovoCodigoSmsVerificacao') === -1 &&
    response.config.url.indexOf('solicitarNovoCodigoSmsVerificacao') === -1 &&
    response.config.url.indexOf('chats') === -1) {
    if (typeof response.data.data === 'string') {
      setToast('success', response.data.data, '', null)
    } else if (response.data.code === 200 || response.data.code === 201) {
      if (response.config.method === 'POST') {
        setToast('success', 'Registro inserido.', '', null)
      } else if (response.config.method === 'PUT') {
        setToast('success', 'Registro atualizado.', '', null)
      } else if (response.config.method === 'DELETE') {
        setToast('success', 'Registro excluído.', '', null)
      }
    }
  }
  $loading.done()
  return response
}

const intercepResponseError = (error) => {
  let rejection = error.response
  if (rejection !== undefined && rejection !== 'undefined') {
    if (rejection.status !== null && rejection.status !== undefined && rejection.status === 500) {
      setToast('error', 'Houve um erro no servidor, por favor tente mas tarde.', '', null)
      // console.log('Error!', 'Houve um erro no servidor, por favor tente mas tarde.')
    }

    if (rejection.status === 401 && rejection.config.url.indexOf('login') < 0 && rejection.config.url.indexOf('menu') < 0) {
      setToast('info', 'Sessão encerrada e/ou usuário não autorizado!', '', null)
      router.push({ name: 'index' })
      // console.log('info', '', 'Recurso não disponível para a sua função.')
    }

    if (rejection.status === 405 || rejection.status === 404 || rejection.status === 403) {
      // || rejection.status === 403) { tratar esse cara depois
      setToast('error', rejection.data.message, '', null)
    }

    if (rejection.status === 400) {
      if (rejection.data && rejection.data.message) {
        setToast('warning', rejection.data.message, '', null)
       // console.log('warning', 'Atenção!', rejection.data.message)
      } else {
        setToast('warning', 'Por favor verifique os valores digitados.', '', null)
        // console.log('warning', 'Atenção!', 'Por favor verifique os valores digitados.')
      }
    }
  }
  $loading.done()
  return error.response
}

http.interceptors.request.use(intercepRequest, intercepRequestError)
http.interceptors.response.use(intercepResponse, intercepResponseError)

export default http



// WEBPACK FOOTER //
// ./src/service/http.js